<template>
  <figure
    :class="['zg-item-solo', {
      'zg-item-solo--full-width': fullWidth,
      'zg-item-solo--vertical': vertical
    }]"
  >
    <div
      v-if="illustration"
      class="image"
    >
      <zg-illustration :illustration="illustration" />
    </div>

    <div
      v-else-if="hasImage"
      class="image"
    >
      <zg-image
        v-if="imageSrc"
        :alt="imageTitle"
        :src="imageSrc"
        :width="160"
        :height="160"
        lazy-load
      />
      <slot name="image" />
    </div>

    <figcaption class="text">
      <h3 v-if="title">
        {{ title }}
      </h3>

      <p
        v-if="text"
        v-html="text"
      />

      <zg-button-link
        v-if="linkUrl && linkText"
        :href="linkUrl"
        :text="linkText"
        :button-props="{
          fullWidthMobile: !linkButton,
          link: linkButton,
          icons: linkButton ? { right: 'arrow-forward' } : undefined
        }"
        @click.native="$emit('btnClicked')"
      />
    </figcaption>
  </figure>
</template>

<script>
  import ZgButtonLink from '../ZgButtonLink/ZgButtonLink.vue'
  import ZgIllustration from '../ZgIllustration/ZgIllustration.vue'
  import ZgImage from '../ZgImage/ZgImage'

  export default {
    name: 'ZgItemSolo',
    components: {
      ZgIllustration,
      ZgButtonLink,
      ZgImage
    },
    props: {
      title: {
        type: String,
        required: false,
        default: ''
      },
      text: {
        type: String,
        required: false,
        default: ''
      },
      linkText: {
        type: String,
        required: false,
        default: null
      },
      linkUrl: {
        type: String,
        required: false,
        default: null
      },
      imageSrc: {
        type: String,
        required: false,
        default: null
      },
      imageTitle: {
        type: String,
        required: false,
        default: ''
      },
      illustration: {
        type: String,
        required: false,
        default: null
      },
      fullWidth: {
        type: Boolean,
        required: false,
        default: false
      },
      linkButton: {
        type: Boolean,
        required: false,
        default: false
      },
      vertical: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    computed: {
      hasImage () {
        return Boolean((this.imageSrc && this.imageTitle) || this.$slots.image)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-item-solo {
    display: flex;
    flex-direction: column;

    .image {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-shrink: 0;
      width: rem(160px);
      height: rem(160px);
      margin: 0 0 rhythm();

      ::v-deep img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }

    .text {
      margin: 0;

      h3 {
        @include type-title-m;
      }

      ::v-deep p {
        margin: 0 0 rhythm();

        &:last-child {
          margin: 0;
        }
      }
    }

    &--full-width {
      width: 100%;
    }

    &--vertical {
      flex-direction: row;
      gap: rhythm();

      .image {
        width: rem(88px);
        height: rem(88px);
      }

      .text {
        h3 {
          @include type-title-m;
          margin-bottom: rem(5px);
        }
      }
    }
  }
</style>
